
import Typography, { TypographyTypeMap } from "@mui/material/Typography";
import { OverridableComponent } from "@mui/material/OverridableComponent";

export const Text: OverridableComponent<TypographyTypeMap> = ({
  ...props
}: any) => <Typography {...props} />;
